import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { CLAIM_DOCUMENT_TYPES, statusActions } from "../../../ISchema";
import { uploadClaimDocument, deleteClaimDocument, fetchClaimDocuments } from "../claimActions";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

var Step4 = function Step4(props) {
  var claim = props.claim,
      token = props.token;

  var _React$useState = React.useState(CLAIM_DOCUMENT_TYPES[0].value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedType = _React$useState2[0],
      setSelectedType = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isUploading = _React$useState4[0],
      setIsUploading = _React$useState4[1];

  var _React$useState5 = React.useState(""),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var queryClient = useQueryClient();

  var _React$useState7 = React.useState([]),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      selectedFiles = _React$useState8[0],
      setSelectedFiles = _React$useState8[1];

  var _React$useState9 = React.useState({}),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      fileTypes = _React$useState10[0],
      setFileTypes = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      dragActive = _React$useState12[0],
      setDragActive = _React$useState12[1];

  var inputRef = React.useRef(null);
  React.useEffect(function () {
    var handleWindowDrop = function handleWindowDrop(e) {
      if (!(e.target && e.target.closest && e.target.closest('.drag-drop-area'))) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener("dragover", handleWindowDrop);
    window.addEventListener("drop", handleWindowDrop);
    return function () {
      window.removeEventListener("dragover", handleWindowDrop);
      window.removeEventListener("drop", handleWindowDrop);
    };
  }, []);

  var _useQuery = useQuery({
    queryKey: ['claimDocuments', claim.id],
    queryFn: function queryFn() {
      return fetchClaimDocuments(claim.id, token);
    },
    select: function select(response) {
      return response.status === "ok" ? response.payload : [];
    }
  }),
      claimDocuments = _useQuery.data,
      isLoading = _useQuery.isLoading;

  var DOCUMENT_TYPE_ACCEPTS = {
    "ClaimDocuments::CompanyClaim": "PDF, JPG, PNG",
    "ClaimDocuments::IncidentImage": "JPG, PNG",
    "ClaimDocuments::InspectionsReports": "PDF",
    "ClaimDocuments::LiquidationPayment": "PDF",
    "ClaimDocuments::LiquidationReport": "PDF",
    "ClaimDocuments::AdditionalDocumentation": "PDF, JPG, PNG",
    "ClaimDocuments::AdjustmentLetter": "PDF",
    "ClaimDocuments::InspectionReport": "PDF",
    "ClaimDocuments::Settlement": "PDF",
    "ClaimDocuments::SentCorrespondence": "PDF, JPG, PNG",
    "ClaimDocuments::ReceivedCorrespondence": "PDF, JPG, PNG",
    "ClaimDocuments::UrgentDocuments": "PDF, JPG, PNG"
  };

  var getTipoDocumentoAceptado = function getTipoDocumentoAceptado(typeValue) {
    return DOCUMENT_TYPE_ACCEPTS[typeValue] || "PDF, JPG, PNG";
  };

  var uploadMutation = useMutation({
    mutationFn: function mutationFn(formData) {
      return uploadClaimDocument(claim.id, formData, token);
    },
    onSuccess: function onSuccess(response) {
      if (response.status === statusActions.ok) {
        queryClient.invalidateQueries({
          queryKey: ['claimDocuments', claim.id]
        });
        setIsUploading(false);
        setError("");
      } else {
        var _response$payload;

        var errorMessage = "Error al subir el documento. Tipo de archivo permitido: ".concat(getTipoDocumentoAceptado(selectedType));

        if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.errors) {
          var errors = response.payload.errors;

          if (errors.document && Array.isArray(errors.document)) {
            errorMessage = errors.document.join(", ");
          } else if (errors.document) {
            errorMessage = errors.document;
          } else if (typeof errors === 'string') {
            errorMessage = errors;
          }
        }

        setError(errorMessage);
        setIsUploading(false);
      }
    },
    onError: function onError() {
      setError("Error al subir el documento. Tipo de archivo permitido: ".concat(getTipoDocumentoAceptado(selectedType)));
      setIsUploading(false);
    }
  });
  var deleteMutation = useMutation({
    mutationFn: function mutationFn(documentId) {
      return deleteClaimDocument(claim.id, documentId, token);
    },
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['claimDocuments', claim.id]
      });
    },
    onError: function onError() {
      setError("Error al eliminar el documento");
    }
  });

  var handleFileInput = function handleFileInput(event) {
    var files = Array.from(event.target.files || []);
    setSelectedFiles(files);
    var initialTypes = Object.fromEntries(files.map(function (f) {
      return [f.name, selectedType];
    }));
    setFileTypes(initialTypes);
  };

  var handleTypeChange = function handleTypeChange(filename, type) {
    setFileTypes(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, filename, type));
    });
  };

  var handleUpload = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _iterator, _step, file, formData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsUploading(true);
              setError("");
              _iterator = _createForOfIteratorHelper(selectedFiles);
              _context.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context.next = 15;
                break;
              }

              file = _step.value;
              formData = new FormData();
              formData.append("claim_document[claim_id]", claim.id.toString());
              formData.append("claim_document[document]", file);
              formData.append("claim_document[type]", fileTypes[file.name]);
              _context.next = 13;
              return uploadMutation.mutateAsync(formData);

            case 13:
              _context.next = 5;
              break;

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);

              _iterator.e(_context.t0);

            case 20:
              _context.prev = 20;

              _iterator.f();

              return _context.finish(20);

            case 23:
              setIsUploading(false);
              setSelectedFiles([]);
              setFileTypes({});

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 17, 20, 23]]);
    }));

    return function handleUpload() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleDeleteDocument = function handleDeleteDocument(documentId) {
    deleteMutation.mutate(documentId);
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (!selectedType || isUploading) return;
    var files = Array.from(e.dataTransfer.files || []);
    setSelectedFiles(files);
    var initialTypes = Object.fromEntries(files.map(function (f) {
      return [f.name, selectedType];
    }));
    setFileTypes(initialTypes);
  };

  var handleAreaClick = function handleAreaClick() {
    var _inputRef$current;

    if (!selectedType || isUploading) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "claim-documents-step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "upload-section mb-4"
  }, /*#__PURE__*/React.createElement("h4", null, "Subir nuevo documento"), /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 d-flex flex-column justify-content-center",
    style: {
      minWidth: 220
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "tipoDocumento"
  }, "Tipo de documento"), /*#__PURE__*/React.createElement("select", {
    id: "tipoDocumento",
    className: "form-control mb-0",
    value: selectedType,
    onChange: function onChange(e) {
      return setSelectedType(e.target.value);
    },
    disabled: isUploading,
    style: {
      minWidth: 180
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione tipo"), CLAIM_DOCUMENT_TYPES.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 d-flex align-items-center",
    style: {
      minHeight: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "drag-drop-area form-control mb-2".concat(dragActive ? " drag-active" : ""),
    style: {
      border: "2px dashed #3399cc",
      borderRadius: 6,
      textAlign: "center",
      padding: 0,
      background: !selectedType ? "#f8f9fa" : dragActive ? "#e6f3fa" : "#f4fbff",
      color: !selectedType ? "#aaa" : "#3399cc",
      cursor: !selectedType || isUploading ? "not-allowed" : "pointer",
      transition: "background 0.2s, border-color 0.2s",
      width: "100%",
      minWidth: 320,
      minHeight: 100,
      height: 48,
      fontSize: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 32,
      aspectRatio: '5/1',
      boxSizing: 'border-box',
      pointerEvents: 'all'
    },
    onClick: handleAreaClick,
    onDragEnter: function onDragEnter(e) {
      e.preventDefault();
      setDragActive(true);
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
      setDragActive(true);
    },
    onDragLeave: function onDragLeave(e) {
      e.preventDefault();
      setDragActive(false);
    },
    onDrop: handleDrop,
    "aria-disabled": !selectedType || isUploading
  }, selectedType ? "Arrastra aquí tus archivos o haz click para seleccionarlos" : "Seleccione primero el tipo de documento", /*#__PURE__*/React.createElement("input", {
    type: "file",
    ref: inputRef,
    onChange: handleFileInput,
    disabled: isUploading || !selectedType,
    multiple: true,
    tabIndex: -1,
    style: {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
      pointerEvents: 'none'
    }
  }))), selectedFiles.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("h5", null, "Archivos a subir"), /*#__PURE__*/React.createElement("table", {
    className: "table table-bordered"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Archivo"), /*#__PURE__*/React.createElement("th", null, "Tipo"))), /*#__PURE__*/React.createElement("tbody", null, selectedFiles.map(function (file) {
    return /*#__PURE__*/React.createElement("tr", {
      key: file.name
    }, /*#__PURE__*/React.createElement("td", null, file.name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("select", {
      className: "form-control",
      value: fileTypes[file.name],
      onChange: function onChange(e) {
        return handleTypeChange(file.name, e.target.value);
      }
    }, CLAIM_DOCUMENT_TYPES.map(function (type) {
      return /*#__PURE__*/React.createElement("option", {
        key: type.value,
        value: type.value
      }, type.label);
    }))));
  }))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: handleUpload,
    disabled: isUploading || selectedFiles.length === 0
  }, "Subir archivos")), isUploading && /*#__PURE__*/React.createElement("p", null, "Cargando documento...")), error && /*#__PURE__*/React.createElement("div", {
    className: "text-danger mt-2"
  }, error)), /*#__PURE__*/React.createElement("div", {
    className: "documents-list"
  }, /*#__PURE__*/React.createElement("h4", null, "Documentos subidos"), isLoading ? /*#__PURE__*/React.createElement("p", null, "Cargando documentos...") : (claimDocuments === null || claimDocuments === void 0 ? void 0 : claimDocuments.length) === 0 ? /*#__PURE__*/React.createElement("p", null, "No hay documentos subidos") : /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Tipo"), /*#__PURE__*/React.createElement("th", null, "Nombre"), /*#__PURE__*/React.createElement("th", null, "Fecha"), /*#__PURE__*/React.createElement("th", null, "Acciones"))), /*#__PURE__*/React.createElement("tbody", null, claimDocuments === null || claimDocuments === void 0 ? void 0 : claimDocuments.map(function (doc) {
    var _CLAIM_DOCUMENT_TYPES;

    return /*#__PURE__*/React.createElement("tr", {
      key: doc.id
    }, /*#__PURE__*/React.createElement("td", null, (_CLAIM_DOCUMENT_TYPES = CLAIM_DOCUMENT_TYPES.find(function (t) {
      return t.value === doc.type;
    })) === null || _CLAIM_DOCUMENT_TYPES === void 0 ? void 0 : _CLAIM_DOCUMENT_TYPES.label), /*#__PURE__*/React.createElement("td", null, doc.document_name), /*#__PURE__*/React.createElement("td", null, new Date(doc.created_at).toLocaleDateString()), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/React.createElement("a", {
      href: doc.document_url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "btn btn-sm btn-info"
    }, "Ver"), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-sm btn-danger",
      onClick: function onClick() {
        return handleDeleteDocument(doc.id);
      },
      disabled: deleteMutation.isLoading
    }, "Eliminar"))));
  }))))));
};

export default Step4;